import * as React from "react";
import style from './PageWrapper.module.scss';

const PageWrapper: React.FC = ({children}) => {
    return <div className={style.container}>
        {children}
    </div>
}
export default PageWrapper